import type { SessionUser } from '../state/session.js';

/**
 * Demo mode kicks in when the app is hosted somewhere other than the local dev
 * box and no explicit API base was provided at build time. That's the only
 * shape under which the user cannot reach the real backend (e.g. embedded inside
 * technovateam.com), so we serve the experience from an in-memory mock.
 */
export const IS_DEMO: boolean = (() => {
  if (typeof window === 'undefined') return false;
  // Manual override so a visitor (or our own dev box) can force the demo on.
  if (new URLSearchParams(window.location.search).get('demo') === '1') return true;
  if (import.meta.env.VITE_API_URL) return false;
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') return false;
  if (host.endsWith('.local')) return false;
  return true;
})();

export const DEMO_USER: SessionUser = {
  id: 'demo-rider-ayesha',
  name: 'Ayesha Khan',
  email: 'ayesha@raahi.test',
  phone: '+923001234567',
  role: 'rider',
};

export const DEMO_TOKENS = {
  accessToken: 'demo-access-token',
  refreshToken: 'demo-refresh-token',
};
